import { render, staticRenderFns } from "./Logistica.vue?vue&type=template&id=3a3f86a1&scoped=true"
import script from "./Logistica.vue?vue&type=script&lang=js"
export * from "./Logistica.vue?vue&type=script&lang=js"
import style0 from "./Logistica.vue?vue&type=style&index=0&id=3a3f86a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f86a1",
  null
  
)

export default component.exports